var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSortingCaretsDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3.53223e-08C6.09658 3.61752e-08 6.1889 0.0348639 6.25522 0.0963869L9.9041 3.481C10.0004 3.57031 10.0268 3.70125 9.97132 3.81408C9.91584 3.92691 9.78908 4 9.64888 4L2.35112 4C2.21092 4 2.08416 3.92691 2.02868 3.81408C1.97319 3.70125 1.99962 3.57031 2.0959 3.481L5.74478 0.0963868C5.8111 0.0348639 5.90342 3.44695e-08 6 3.53223e-08Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C5.90342 12 5.8111 11.9651 5.74478 11.9036L2.0959 8.519C1.99962 8.42969 1.97319 8.29875 2.02868 8.18592C2.08416 8.07309 2.21092 8 2.35112 8L9.64888 8C9.78908 8 9.91584 8.07309 9.97132 8.18592C10.0268 8.29875 10.0004 8.42969 9.9041 8.519L6.25522 11.9036C6.1889 11.9651 6.09658 12 6 12Z",
    fill: "#757575"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingCaretsDisabled);
export default __webpack_public_path__ + "static/media/sorting-carets-disabled.4c363f0fb3df0b4091d63a21afe15411.svg";
export { ForwardRef as ReactComponent };